<script lang="ts">
  import { fade } from "svelte/transition";
  export let color = "rgba(0, 0, 0, 0.50);";
</script>

<svg
  width="65"
  height="65"
  viewBox="0 0 65 65"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="32" cy="33" r="30" fill={color} />
  <path
    d="M44.3118 41.9993L35.8125 33.5L44.3118 25.0007C45.2294 24.0831 45.2294 22.6058 44.3118 21.6882C43.3942 20.7706 41.9169 20.7706 40.9993 21.6882L32.5 30.1875L24.0007 21.6882C23.0831 20.7706 21.6058 20.7706 20.6882 21.6882C19.7706 22.6058 19.7706 24.0831 20.6882 25.0007L29.1875 33.5L20.6882 41.9993C19.7706 42.9169 19.7706 44.3942 20.6882 45.3118C21.6058 46.2294 23.0831 46.2294 24.0007 45.3118L32.5 36.8125L40.9993 45.3118C41.9169 46.2294 43.3942 46.2294 44.3118 45.3118C45.2229 44.3942 45.2229 42.9104 44.3118 41.9993Z"
    fill="white"
  />
</svg>
